import axios from 'axios';

// Descarga un archivo del API enviando el token de sesión (axios lo agrega en la
// cabecera Authorization). Reemplaza a window.location.href / window.open, que
// navegan sin cabeceras y por lo tanto sin autenticación.
class DownloadService {

    async download(url, defaultFileName = 'descarga') {
        const response = await axios.get(url, { responseType: 'blob' });

        const objectUrl = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.setAttribute('download', this.fileNameFrom(response.headers['content-disposition']) || defaultFileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(objectUrl);

        return response;
    }

    fileNameFrom(contentDisposition) {
        if (!contentDisposition) return null;
        const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
        if (utf8) return decodeURIComponent(utf8[1]);
        const plain = /filename="?([^";]+)"?/i.exec(contentDisposition);
        return plain ? plain[1].trim() : null;
    }
}

const instance = new DownloadService()
export default instance
